<div class="mobile-menu-popover" [class.food-only]="isFoodOnly">
  <!-- Modern Header with Quick Actions -->
  <div class="menu-header">
    <div class="header-content">
      <div class="header-title-section">
        <h2 class="header-title">{{isFoodOnly ? 'Food & Catering' : 'Menu'}}</h2>
        <p class="header-subtitle">{{isFoodOnly ? 'Choose a restaurant' : 'Quick access to all features'}}</p>
      </div>
      <div class="header-actions">
        <button *ngIf="!isFoodOnly" class="action-button theme-toggle" (click)="toggleTheme()" [attr.aria-label]="isDarkmode ? 'Switch to light mode' : 'Switch to dark mode'">
          <ion-icon [name]="isDarkmode ? 'sunny-outline' : 'moon-outline'"></ion-icon>
        </button>
        <button class="action-button settings-btn" (click)="toggleSettings()" aria-label="Settings" [class.always-visible]="!appPages || appPages.length === 0">
          <ion-icon name="settings-outline"></ion-icon>
        </button>
        <button class="action-button close-btn" (click)="closePopover()" aria-label="Close">
          <ion-icon name="close-outline"></ion-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Quick Settings Panel (Slide Down) -->
  <div *ngIf="showSettings && (!isFoodOnly || (!appPages || appPages.length === 0))" class="settings-panel">
    <div class="settings-header">
      <h3>Settings</h3>
    </div>
    <div class="settings-grid">
      <button class="settings-card" (click)="selectProfile()">
        <div class="settings-icon-wrapper profile">
          <ion-icon name="people-outline"></ion-icon>
        </div>
        <div class="settings-content">
          <span class="settings-title">Change Profile</span>
          <span class="settings-subtitle">Switch user profile</span>
        </div>
        <ion-icon name="chevron-forward-outline" class="chevron"></ion-icon>
      </button>
      
      <button class="settings-card" (click)="editMenu()">
        <div class="settings-icon-wrapper customize">
          <ion-icon name="create-outline"></ion-icon>
        </div>
        <div class="settings-content">
          <span class="settings-title">Customize Menu</span>
          <span class="settings-subtitle">Edit your menu items</span>
        </div>
        <ion-icon name="chevron-forward-outline" class="chevron"></ion-icon>
      </button>
    </div>
  </div>

  <!-- Main Menu Grid - Modern Card Layout -->
  <div class="menu-content">
    <!-- Show message if menu is empty -->
    <div *ngIf="!appPages || appPages.length === 0" class="empty-menu-message">
      <ion-icon name="alert-circle-outline"></ion-icon>
      <p>No menu items available.</p>
      <p class="subtitle">Please select a profile from settings.</p>
      <ion-button (click)="toggleSettings()" fill="outline" size="small">
        Open Settings
      </ion-button>
    </div>
    
    <div *ngIf="appPages && appPages.length > 0" class="menu-items-grid">
      <ng-container *ngFor="let page of appPages">
        <!-- Main page without subpages -->
        <button *ngIf="!page.subPages" class="menu-card" (click)="navigate(page.url)">
          <div class="menu-card-icon">
            <ion-icon [name]="page.icon"></ion-icon>
          </div>
          <span class="menu-card-label">{{page.title}}</span>
        </button>

        <!-- Main page with subpages -->
        <div *ngIf="page.subPages" class="menu-card-container">
          <!-- In food-only mode, show subpages directly without expandable button -->
          <ng-container *ngIf="isFoodOnly">
            <ng-container *ngFor="let subpage of page.subPages">
              <button 
                *ngIf="subpage.display"
                class="menu-card"
                (click)="navigate(subpage.url)">
                <div class="menu-card-icon">
                  <ion-icon *ngIf="subpage.icon" [name]="subpage.icon"></ion-icon>
                  <ion-icon *ngIf="!subpage.icon" name="restaurant-outline"></ion-icon>
                </div>
                <span class="menu-card-label">{{subpage.title}}</span>
              </button>
            </ng-container>
          </ng-container>
          
          <!-- In full menu mode, show expandable button -->
          <ng-container *ngIf="!isFoodOnly">
            <button class="menu-card expandable" (click)="toggleDropdown(page.title)" [class.expanded]="isDropdownOpen(page.title)">
              <div class="menu-card-icon">
                <ion-icon [name]="page.icon || 'stats-chart'"></ion-icon>
              </div>
              <span class="menu-card-label">{{page.title}}</span>
              <ion-icon name="chevron-down-outline" class="expand-icon"></ion-icon>
            </button>
            
            <!-- Subpages - Animated Dropdown -->
            <div *ngIf="isDropdownOpen(page.title)" class="submenu-container">
              <div class="submenu-grid">
                <ng-container *ngFor="let subpage of page.subPages">
                  <button 
                    *ngIf="subpage.display"
                    class="menu-card submenu-card"
                    (click)="navigate(subpage.url)">
                    <div class="menu-card-icon small">
                      <ion-icon *ngIf="subpage.icon" [name]="subpage.icon"></ion-icon>
                      <ion-icon *ngIf="!subpage.icon" name="ellipse-outline"></ion-icon>
                    </div>
                    <span class="menu-card-label">{{subpage.title}}</span>
                  </button>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
      
      <!-- FAQ Card - Only show in full menu, not in food-only mode -->
      <button *ngIf="!isFoodOnly" class="menu-card faq-card" (click)="navigate('/infopage')">
        <div class="menu-card-icon">
          <ion-icon name="help-circle-outline"></ion-icon>
        </div>
        <span class="menu-card-label">FAQ</span>
      </button>
    </div>
  </div>
</div>

